import { startOfYear, sub } from 'date-fns'

import { TODAY } from '@/const'

import { SpeedDialRange } from './speed-dial-section'

export const last7Days: SpeedDialRange = {
  label: 'Last 7 days',
  value: [sub(TODAY, { days: 7 }), TODAY]
}
export const last30Days: SpeedDialRange = {
  label: 'Last 30 days',
  value: [sub(TODAY, { days: 30 }), TODAY]
}
export const last90Days: SpeedDialRange = {
  label: 'Last 90 days ',
  value: [sub(TODAY, { days: 90 }), TODAY]
}
export const lastYear: SpeedDialRange = {
  label: 'Last year',
  value: [sub(TODAY, { years: 1 }), TODAY]
}
export const yearToDate: SpeedDialRange = {
  label: 'Year to date',
  value: [startOfYear(TODAY), TODAY]
}
